import React, { Component } from 'react';
import PropTypes from 'prop-types';

import co from 'co';

// the class within will try to be handed a ref, which
// fails if it's a stateless function component.
/* eslint-disable react/prefer-stateless-function */

/**
 * There are times when clicking a link that you may want to
 * show a dialog to prevent a user from proceeding, or to confirm
 * an action. This HOC provides an interface for showing that
 * dialog, going to the eventual target (maybe), and handling
 * motifying a backend service if the user doesn't want to see
 * this dialog again. Everything is wrapped up in a prop
 * that is passed down to the wrapped component, so that
 * all the component has to do is call the prop and all this
 * behavior is handled for it in a consistent way.
 */
export default function maybeShowPreTargetDialog({
  markUserDialogPreference,
  goToTarget,
  openDialog,
  dialogKeyTemplate,
  name,
}) {
  return (component) => (
    class PreTargetDialogWrapper extends Component {
      static propTypes = {
        user: PropTypes.shape({
          settings: PropTypes.object.isRequired,
          id: PropTypes.any.isRequired,
        }).isRequired,
      };

      render() {
        const { user: { settings, id } } = this.props;

        const hasUserSeenDialog = (args) => (
          settings[dialogKeyTemplate(args)]
        );

        const markUserAsHavingSeenDialog = (args) => {
          markUserDialogPreference(
            id,
            dialogKeyTemplate(args),
            this.props,
          );
        };

        return React.createElement(
          component,
          {
            ...this.props,
            [name]: (args) => {
              if (hasUserSeenDialog(args)) {
                goToTarget(args);

                return null;
              }

              // openDialog can accept a standard function
              // or generator. using a generator is handy
              // because we can use a Promise to wait for a
              // modal action to happen, resolving or rejecting
              // as needed. you'll get back the result of
              // openDialog, whatever that may be.
              const result = openDialog(
                args,
                this.props,
                {
                  goToTarget: () => {
                    goToTarget(args);
                  },
                  markUserAsHavingSeenDialog: () => {
                    markUserAsHavingSeenDialog(args);
                  },
                }
              );

              if (result && result.next) { return co(result); }

              return result;
            },
          }
        );
      }
    }
  );
}
